
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import data from "./data";
interface SourceData {
  [x: string]: any;
}
export interface BgAreaSelectOption {
  code: string;
  codePath: string;
  name: string;
  leaf?: boolean;
  disabled?: boolean;
  children?: BgAreaSelectOption[];
}
@Component({
  model: {
    prop: "value",
    event: "change",
  },
})
export default class BgAreaSelect extends Vue {
  @Prop() value!: string[];
  @Prop() props?: { [x: string]: any };
  @Prop() optionDisabled?: (node: BgAreaSelectOption, level: number) => boolean;
  @Prop({ default: true }) match?: boolean;
  @Prop({ default: true }) clearable?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  selection: string[] = [];
  options: BgAreaSelectOption[] = [];
  provinces: BgAreaSelectOption[] = [];
  cities: BgAreaSelectOption[] = [];
  areas: BgAreaSelectOption[] = [];
  get cascaderProps(): { [x: string]: any } {
    return {
      label: "name",
      value: "code",
      checkStrictly: true,
      ...(this.props || {}),
    };
  }
  @Watch("value")
  handleValueChange(val: string[]): void {
    this.selection = val;
    this.matchValues();
  }
  created(): void {
    this.selection = this.value;
    const options = this.genOptions(data);
    this.options = options;
    this.matchValues();
  }
  matchValues(): void {
    const matchedProvince = this.provinces.find(
      (ele) =>
        this.selection[0] &&
        (ele.name.indexOf(this.selection[0]) >= 0 ||
          this.selection[0].indexOf(ele.name) >= 0)
    );
    const matchedCity = this.cities.find(
      (ele) =>
        matchedProvince &&
        ele.codePath.indexOf(matchedProvince.codePath) >= 0 &&
        this.selection[1] &&
        (ele.name.indexOf(this.selection[1]) >= 0 ||
          this.selection[1].indexOf(ele.name) >= 0)
    );
    const matchedArea = this.areas.find(
      (ele) =>
        matchedCity &&
        ele.codePath.indexOf(matchedCity.codePath) >= 0 &&
        this.selection[2] &&
        (this.selection[2].indexOf(ele.name) >= 0 ||
          ele.name.indexOf(this.selection[2]) >= 0)
    );
    const selection = [];
    if (matchedProvince) {
      selection.push(matchedProvince.name);
    }
    if (matchedCity) {
      selection.push(matchedCity.name);
    }
    if (matchedArea) {
      selection.push(matchedArea.name);
    }
    this.selection = selection;
  }
  genOptions(data: SourceData): BgAreaSelectOption[] {
    return this.genChildOptions(data, data["0"], "0");
  }
  genChildOptions(
    data: SourceData,
    item: SourceData,
    parentCode: string,
    level = 1
  ): BgAreaSelectOption[] {
    const cascaderPropsValue = this.cascaderProps.value;
    if (data && typeof data === "object") {
      return Object.entries(item).map(([key, value]) => {
        const childrenKey = [parentCode, key].join(",");
        const codePath = [parentCode, key].join(",");
        const opt: BgAreaSelectOption = {
          code: key,
          codePath: codePath,
          name: value,
        };
        if (typeof this.optionDisabled === "function") {
          const disabled = this.optionDisabled(opt, level);
          opt.disabled = disabled;
        }
        let childrenData = data[childrenKey];
        // 无分区的市补偿
        if (
          level === 2 &&
          Array.isArray(childrenData) &&
          childrenData.length === 0
        ) {
          childrenData = {
            [opt.code + "00"]: opt.name,
          };
        }
        let children = data[childrenKey]
          ? this.genChildOptions(data, childrenData, codePath, level + 1)
          : [];
        const isLeaf = !data[childrenKey];
        if (isLeaf) {
          opt.leaf = isLeaf;
        }
        if (children.length) {
          opt.children = children;
        }
        if (this.match && cascaderPropsValue === "name") {
          if (level === 1) {
            this.provinces.push(opt);
          } else if (level === 2) {
            this.cities.push(opt);
          } else if (level === 3) {
            this.areas.push(opt);
          }
        }
        return opt;
      });
    }
    return [];
  }
  handleChange(val: string[]): void {
    this.$emit("change", val);
  }
}
